import React from 'react';
import { RiStarLine, RiHome4Line, RiWechatLine } from 'react-icons/ri';

const iconList = [RiStarLine, RiHome4Line, RiWechatLine];

export default function UniqueValueProposition({ data }) {
    return (
        <div className="unique-value-proposition">
            <div className="unique-value-proposition__header">
                <h2 className="unique-value-proposition__title">{data?.title}</h2>
            </div>
            <div className="unique-value-proposition-items">
                {data?.items?.map((item, index) => {
                    const Icon = iconList[index] || null;
                    return (
                        <div key={index} className="unique-value-proposition__item">
                            <div className="unique-value-proposition__item-icon-wrapper">
                                <Icon className="unique-value-proposition__item-icon" />
                            </div>
                            <div className="unique-value-proposition__item-content">
                                <span className="unique-value-proposition__item-content-upper-text">
                                    {item.titleTranslaton}
                                    {item.titleTranslatonExtraContent && (
                                        <span className="unique-value-proposition__item-content-upper-text-extra-txt">
                                            &nbsp;{item.titleTranslatonExtraContent}
                                        </span>
                                    )}
                                </span>
                                <span className="unique-value-proposition__item-content-bottom-text">
                                    {item.descriptionTranslation}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
